import AuthorisedRoutes from "./Routes/AuthorisedRoutes";
import GenericRoutes from "./Routes/GenericRoutes";
import UnAuthorisedRoutes from "./Routes/UnAuthorisedRoutes";

const AppRoutes = [
  ...UnAuthorisedRoutes,
  ...AuthorisedRoutes,
  ...GenericRoutes
];

export default AppRoutes;
